import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { Button, Menu } from '@elementary/common-ui/components';
import { RunType, VisibleRunTypes } from './types';

const OPTIONS: Array<{ value: RunType; label: string }> = [
  { value: 'agent', label: 'Agent' },
  { value: 'ci', label: 'CI' },
];

type Props = {
  value: VisibleRunTypes;
  onChange: (value: VisibleRunTypes) => void;
};

const RunTypeFilter = ({ value, onChange }: Props) => {
  const selectedOptions = OPTIONS.map((o) => o.value).filter(
    (type) => value[type],
  );

  const handleChange = (items: string[]) => {
    if (items.length === 0) {
      return;
    }
    onChange({
      agent: items.includes('agent'),
      ci: items.includes('ci'),
    });
  };

  return (
    <Menu
      multiple
      options={OPTIONS}
      selectedOptions={selectedOptions}
      onChange={handleChange}
      menuButton={
        <Button variant="outlined" startIcon={<FilterAltOutlinedIcon />}>
          Filter
        </Button>
      }
    />
  );
};

export default RunTypeFilter;
